import { Button, Col, Image, Row, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import RomanPillarImage from "../../assets/images/roman-pillar.webp";
import { APP_DOMAIN } from "../../utls/constants";
import "./index.less";

const { Paragraph } = Typography;

const HomePageAgencySection = () => {
  const { t } = useTranslation();
  const btnArr = [
    { key: "to-start-up", href: `https://business.${APP_DOMAIN}/` },
    { key: "security-contact-text", href: "/contact" },
  ];

  return (
    <div>
      <Row className="contact_main" justify="center">
        <Row className="contact-container">
          <Col className="content-col">
            <div className="main-title">{t("home-page-agency-section-title")}</div>
            <Paragraph className="text-row">
              <Paragraph className="Contact_description">{t("home-page-agency-section-p1")}</Paragraph>
              <Paragraph className="Contact_description">{t("home-page-agency-section-p2")}</Paragraph>
            </Paragraph>
            <Row className="button-row">
              {btnArr.map((item, index) => (
                <Col key={index}>
                  <Link to={item?.href}>
                    {" "}
                    <Button className={`custom-button ${index === 0 ? "primary-button" : "secondary-button"}`} block>
                      {t(item.key)}
                    </Button>
                  </Link>
                </Col>
              ))}
            </Row>
          </Col>
          <Col className="image-col">
            <Image src={RomanPillarImage} alt="Roman Pillar" className="roman-pillar-image" preview={false} loading="eager" placeholder={true} />
          </Col>
        </Row>
      </Row>
    </div>
  );
};

export default HomePageAgencySection;
